// Enumerations
import { ModalReferencesEnumeration } from 'enumerations/modal-references.enumeration';

const ONBOARDING_GIL_MODAL_SHOW_MODAL = {
  [ModalReferencesEnumeration.CANCEL_PROCESS]:
    'El modal de cancelar el proceso de onboarding, dado que el cliente le ha dado a cancelar de manera consciente, se le ha mostrado.',
  [ModalReferencesEnumeration.DROP_PROCESS]:
    'El modal de abandonar el proceso de onboarding, porque el usuario esta intentando salir desde el navegador pinchando en botones o de manera no guiada, se le ha mostrado.',
  [ModalReferencesEnumeration.ERROR_CANCEL_PROCESS]:
    'El modal de cancelar el proceso de onboarding desde la pantalla de error se ha mostrado al cliente.',
  [ModalReferencesEnumeration.KYC_ACCOUNT_CHECK]:
    'El modal de KYC mediante verificación de cuenta bancaria con los detalles de la operativa se ha mostrado al cliente.',
  [ModalReferencesEnumeration.KYC_BIZUM]:
    'El modal de KYC mediante Bizum con los detalles de la operativa se ha mostrado al cliente.',
  [ModalReferencesEnumeration.KYC_VIDEOCALL]:
    'El modal de KYC mediante Videollamada con los detalles de la operativa se ha mostrado al cliente.',
  [ModalReferencesEnumeration.POI_OPENBANKING]:
    'El modal para verificar los ingresos mediante Openbanking se ha mostrado al cliente.',
  [ModalReferencesEnumeration.POI_TGSS]:
    'El modal para verificar los ingresos mediante la Seguridad Social (TGSS) se ha mostrado al cliente.',
};

export { ONBOARDING_GIL_MODAL_SHOW_MODAL };
